import axios from "axios";

export const getGoogleScopeOfUser = async ({ accessToken }) => {
  try {
    const { data } = await axios.get(
      `https://www.googleapis.com/oauth2/v3/tokeninfo`,
      {
        params: { access_token: accessToken },
      }
    );
    return data;
  } catch (err) {
    // console.log(err);
  }
};
